var _regeneratorRuntime = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e5) { throw _e5; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e6) { didErr = true; err = _e6; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

module.exports = function (e) {
  var t = {};

  function n(s) {
    if (t[s]) return t[s].exports;
    var r = t[s] = {
      i: s,
      l: !1,
      exports: {}
    };
    return e[s].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, s) {
    n.o(e, t) || Object.defineProperty(e, t, {
      configurable: !1,
      enumerable: !0,
      get: s
    });
  }, n.r = function (e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "/dist/", n(n.s = 1);
}([function (e, t, n) {
  "use strict";

  n.r(t);
  var s = {
    equal: 0,
    delete: 1,
    insert: 2,
    none: 3,
    replace: 4
  };

  var r = /*#__PURE__*/function () {
    function r(e, t, n) {
      _classCallCheck(this, r);

      this.startInOld = e, this.startInNew = t, this.size = n;
    }

    _createClass(r, [{
      key: "endInOld",
      get: function get() {
        return this.startInOld + this.size;
      }
    }, {
      key: "endInNew",
      get: function get() {
        return this.startInNew + this.size;
      }
    }]);

    return r;
  }();

  var i = function i() {
    _classCallCheck(this, i);

    this.blockSize = 0, this.repeatingWordsAccuracy = 0, this.ignoreWhitespaceDifferences = !1;
  };

  var o = /^\s*<\/?[^>]+>\s*$/,
      l = /<[^\s>]+/,
      h = /^(\s|&nbsp;)+$/,
      c = /[\w\#@]+/,
      d = ["<img"];

  function a(e) {
    return !d.some(function (t) {
      return null !== e && e.startsWith(t);
    }) && o.test(e);
  }

  function u(e, t, n) {
    return ["<", t, ' class="', n, '">', e, "</", t, ">"].join("");
  }

  function p(e) {
    return "<" === e;
  }

  function f(e) {
    return "&" === e;
  }

  function w(e) {
    return ";" === e;
  }

  function g(e) {
    return h.test(e);
  }

  function I(e) {
    return a(e) ? function (e) {
      return e = l.exec(e)[0] + (e.endsWith("/>") ? "/>" : ">");
    }(e) : e;
  }

  function W(e) {
    return c.test(e);
  }

  function O(e, t, n) {
    return e.push(t), e.length > n && e.shift(), e.length !== n ? null : e.join("");
  }

  var x = /*#__PURE__*/function () {
    function x(e, t, n, s, r, i, o) {
      _classCallCheck(this, x);

      this.oldWords = e, this.newWords = t, this.startInOld = n, this.endInOld = s, this.startInNew = r, this.endInNew = i, this.options = o;
    }

    _createClass(x, [{
      key: "indexNewWords",
      value: function indexNewWords() {
        this.wordIndices = new Map();
        var e = [];

        for (var _t = this.startInNew; _t < this.endInNew; _t++) {
          var _n = O(e, this.normalizeForIndex(this.newWords[_t]), this.options.blockSize);

          null !== _n && (this.wordIndices.has(_n) ? this.wordIndices.get(_n).push(_t) : this.wordIndices.set(_n, [_t]));
        }
      }
    }, {
      key: "normalizeForIndex",
      value: function normalizeForIndex(e) {
        return e = I(e), this.options.IgnoreWhiteSpaceDifferences && g(e) ? " " : e;
      }
    }, {
      key: "findMatch",
      value: function findMatch() {
        if (this.indexNewWords(), this.removeRepeatingWords(), 0 === this.wordIndices.length) return null;
        var e = this.startInOld,
            t = this.startInNew,
            n = 0,
            s = new Map();
        var i = this.options.blockSize;
        var o = [];

        for (var _r = this.startInOld; _r < this.endInOld; _r++) {
          var _l = O(o, this.normalizeForIndex(this.oldWords[_r]), i);

          if (null === _l) continue;

          var _h = new Map();

          if (this.wordIndices.has(_l)) {
            var _iterator = _createForOfIteratorHelper(this.wordIndices.get(_l)),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _o = _step.value;

                var _l2 = (s.has(_o - 1) ? s.get(_o - 1) : 0) + 1;

                _h.set(_o, _l2), _l2 > n && (e = _r - _l2 - i + 2, t = _o - _l2 - i + 2, n = _l2);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            s = _h;
          } else s = _h;
        }

        return 0 !== n ? new r(e, t, n + i - 1) : null;
      }
    }, {
      key: "removeRepeatingWords",
      value: function removeRepeatingWords() {
        var e = this.newWords.length + this.options.repeatingWordsAccuracy,
            t = Array.from(this.wordIndices.entries()).filter(function (t) {
          return t[1].length > e;
        }).map(function (e) {
          return e[0];
        });

        var _iterator2 = _createForOfIteratorHelper(t),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e = _step2.value;
            this.wordIndices.delete(_e);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }]);

    return x;
  }();

  var m = function m(e, t, n, s, r) {
    _classCallCheck(this, m);

    this.action = e, this.startInOld = t, this.endInOld = n, this.startInNew = s, this.endInNew = r;
  };

  var b = {
    character: 0,
    tag: 1,
    whitespace: 2,
    entity: 3
  };

  function N(e, t) {
    var n = {
      mode: b.character,
      currentWord: [],
      words: []
    },
        s = function (e, t) {
      var n = new Map();
      if (null === t) return n;

      var _iterator3 = _createForOfIteratorHelper(t),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _s = _step3.value;

          var _t2 = void 0;

          for (; null !== (_t2 = _s.exec(e));) {
            if (n.has(_t2.index)) throw new Error("One or more block expressions result in a text sequence that overlaps. Current expression: " + _s.toString());
            n.set(_t2.index, _t2.index + _t2[0].length);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return n;
    }(e, t),
        r = !!s.size,
        i = !1,
        o = -1;

    for (var _t3 = 0; _t3 < e.length; _t3++) {
      var l = e[_t3];

      if (r) {
        o === index && (o = -1, i = !1);
        var _e2 = 0;

        if (s.has(index) && (i = !0, o = _e2 = s.get(index)), i) {
          n.currentWord.push(l), n.mode = b.character;
          continue;
        }
      }

      switch (n.mode) {
        case b.character:
          p(l) ? k(n, "<", b.tag) : f(l) ? k(n, l, b.entity) : g(l) ? k(n, l, b.whitespace) : W(l) && (0 === n.currentWord.length || W(n.currentWord[n.currentWord.length - 1])) ? n.currentWord.push(l) : k(n, l, b.character);
          break;

        case b.tag:
          ">" === l ? (n.currentWord.push(l), n.words.push(n.currentWord.join("")), n.currentWord = [], n.mode = g(l) ? b.whitespace : b.character) : n.currentWord.push(l);
          break;

        case b.whitespace:
          p(l) ? k(n, l, b.tag) : f(l) ? k(n, l, b.entity) : g(l) ? n.currentWord.push(l) : k(n, l, b.character);
          break;

        case b.entity:
          if (p(l)) k(n, l, b.tag);else if (g(l)) k(n, l, b.whitespace);else if (w(l)) {
            var _e3 = !0;

            if (0 !== n.currentWord.length && (n.currentWord.push(l), n.words.push(n.currentWord.join("")), n.words.length > 2 && g(n.words[n.words.length - 2]) && g(n.words[n.words.length - 1]))) {
              var _t4 = n.words[n.words.length - 2],
                  _s2 = n.words[n.words.length - 1];
              n.words.splice(n.words.length - 2, 2), n.currentWord = [(_t4 + _s2).split()], n.mode = b.whitespace, _e3 = !1;
            }

            _e3 && (n.currentWord = [], n.mode = b.character);
          } else W(l) ? n.currentWord.push(l) : k(n, l, b.character);
      }
    }

    return 0 !== n.currentWord.length && n.words.push(n.currentWord.join("")), n.words;
  }

  function k(e, t, n) {
    0 !== e.currentWord.length && e.words.push(e.currentWord.join("")), e.currentWord = [t], e.mode = n;
  }

  var y = 4,
      M = new Map([["</strong>", 0], ["</em>", 0], ["</b>", 0], ["</i>", 0], ["</big>", 0], ["</small>", 0], ["</u>", 0], ["</sub>", 0], ["</strike>", 0], ["</s>", 0]]),
      T = /<((strong)|(b)|(i)|(em)|(big)|(small)|(u)|(sub)|(sup)|(strike)|(s))[\>\s]+/gi;

  var v = /*#__PURE__*/function () {
    function v(e, t) {
      _classCallCheck(this, v);

      this.content = [], this.newText = t, this.oldText = e, this.specialTagDiffStack = [], this.newWords = [], this.oldWords = [], this.matchGranularity = 0, this.blockExpressions = [], this.repeatingWordsAccuracy = 1, this.ignoreWhiteSpaceDifferences = !1, this.orphanMatchThreshold = 0;
    }

    _createClass(v, [{
      key: "build",
      value: function build() {
        if (this.oldText === this.newText) return this.newText;
        this.splitInputsIntoWords(), this.matchGranularity = Math.min(y, this.oldWords.length, this.newWords.length);
        var e = this.operations();

        var _iterator4 = _createForOfIteratorHelper(e),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t5 = _step4.value;
            this.performOperation(_t5);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        return this.content.join("");
      }
    }, {
      key: "addBlockExpression",
      value: function addBlockExpression(e) {
        this.blockExpressions.push(e);
      }
    }, {
      key: "splitInputsIntoWords",
      value: function splitInputsIntoWords() {
        this.oldWords = N(this.oldText, this.blockExpressions), this.oldText = null, this.newWords = N(this.newText, this.blockExpressions), this.newText = null;
      }
    }, {
      key: "performOperation",
      value: function performOperation(e) {
        switch (e.action) {
          case s.equal:
            this.processEqualOperation(e);
            break;

          case s.delete:
            this.processDeleteOperation(e, "diffdel");
            break;

          case s.insert:
            this.processInsertOperation(e, "diffins");
            break;

          case s.none:
            break;

          case s.replace:
            this.processReplaceOperation(e);
        }
      }
    }, {
      key: "processReplaceOperation",
      value: function processReplaceOperation(e) {
        this.processDeleteOperation(e, "diffmod"), this.processInsertOperation(e, "diffmod");
      }
    }, {
      key: "processInsertOperation",
      value: function processInsertOperation(e, t) {
        var n = this.newWords.filter(function (t, n) {
          return n >= e.startInNew && n < e.endInNew;
        });
        this.insertTag("ins", t, n);
      }
    }, {
      key: "processDeleteOperation",
      value: function processDeleteOperation(e, t) {
        var n = this.oldWords.filter(function (t, n) {
          return n >= e.startInOld && n < e.endInOld;
        });
        this.insertTag("del", t, n);
      }
    }, {
      key: "processEqualOperation",
      value: function processEqualOperation(e) {
        var t = this.newWords.filter(function (t, n) {
          return n >= e.startInNew && n < e.endInNew;
        });
        this.content.push(t.join(""));
      }
    }, {
      key: "insertTag",
      value: function insertTag(e, t, n) {
        for (; n.length;) {
          var _s3 = this.extractConsecutiveWords(n, function (e) {
            return !a(e);
          }),
              _r2 = "",
              _i = !1;

          if (0 !== _s3.length) {
            var _n2 = u(_s3.join(""), e, t);

            this.content.push(_n2);
          } else {
            if (T.test(n[0])) {
              if (this.specialTagDiffStack.push(n[0]), _r2 = '<ins class="mod">', "del" === e) for (n.shift(); n.length > 0 && T.test(n[0]);) {
                n.shift();
              }
            } else if (M.has(n[0])) {
              var _t6 = 0 === this.specialTagDiffStack.length ? null : this.specialTagDiffStack.pop();

              if (null !== _t6 && _t6 === n[0].replace(/\//g, "") && (_r2 = "</ins>", _i = !0), "del" === e) for (n.shift(); n.length > 0 && M.has(n[0]);) {
                n.shift();
              }
            }

            if (0 === n.length && 0 === _r2.length) break;
            _i ? this.content.push(_r2 + this.extractConsecutiveWords(n, a).join("")) : this.content.push(this.extractConsecutiveWords(n, a).join("") + _r2);
          }
        }
      }
    }, {
      key: "extractConsecutiveWords",
      value: function extractConsecutiveWords(e, t) {
        var n = null;

        for (var _s4 = 0; _s4 < e.length; _s4++) {
          var _r3 = e[_s4];

          if (0 === _s4 && " " === _r3 && (e[_s4] = "&nbsp;"), !t(_r3)) {
            n = _s4;
            break;
          }
        }

        if (null !== n) {
          var _t7 = e.filter(function (e, t) {
            return t >= 0 && t < n;
          });

          return n > 0 && e.splice(0, n), _t7;
        }

        {
          var _t8 = e.filter(function (t, n) {
            return n >= 0 && n < e.length;
          });

          return e.splice(0, e.length), _t8;
        }
      }
    }, {
      key: "operations",
      value: function operations() {
        var e = 0,
            t = 0,
            n = [],
            i = this.matchingBlocks();
        i.push(new r(this.oldWords.length, this.newWords.length, 0));
        var o = this.removeOrphans(i);

        var _iterator5 = _createForOfIteratorHelper(o),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _r4 = _step5.value;

            var _i2 = void 0,
                _o2 = e === _r4.startInOld,
                _l3 = t === _r4.startInNew;

            (_i2 = _o2 || _l3 ? _o2 && !_l3 ? s.insert : _o2 ? s.none : s.delete : s.replace) !== s.none && n.push(new m(_i2, e, _r4.startInOld, t, _r4.startInNew)), 0 !== _r4.length && n.push(new m(s.equal, _r4.startInOld, _r4.endInOld, _r4.startInNew, _r4.endInNew)), e = _r4.endInOld, t = _r4.endInNew;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        return n;
      }
    }, {
      key: "removeOrphans",
      value: /*#__PURE__*/_regeneratorRuntime.mark(function removeOrphans(e) {
        var t, n, _iterator6, _step6, _s5, _e4, _i3, _o3;

        return _regeneratorRuntime.wrap(function removeOrphans$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = null, n = null;
                _iterator6 = _createForOfIteratorHelper(e);
                _context.prev = 2;

                _iterator6.s();

              case 4:
                if ((_step6 = _iterator6.n()).done) {
                  _context.next = 24;
                  break;
                }

                _s5 = _step6.value;

                if (!(null === n)) {
                  _context.next = 9;
                  break;
                }

                t = new r(0, 0, 0), n = _s5;
                return _context.abrupt("continue", 22);

              case 9:
                if (!(t.endInOld === n.startInOld && t.endInNew === n.startInNew || n.endInOld === _s5.startInOld && n.endInNew === _s5.startInNew)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 12;
                return n;

              case 12:
                t = n;
                n = _s5;
                return _context.abrupt("continue", 22);

              case 15:
                _e4 = function _e4(e, t) {
                  return e + t.length;
                }, _i3 = this.oldWords.slice(t.endInOld, _s5.startInOld).reduce(_e4, 0), _o3 = this.newWords.slice(t.endInNew, _s5.startInNew).reduce(_e4, 0);
                _context.t0 = this.newWords.slice(n.startInNew, n.endInNew).reduce(_e4, 0) > Math.max(_i3, _o3) * this.orphanMatchThreshold;

                if (!_context.t0) {
                  _context.next = 20;
                  break;
                }

                _context.next = 20;
                return n;

              case 20:
                t = n;
                n = _s5;

              case 22:
                _context.next = 4;
                break;

              case 24:
                _context.next = 29;
                break;

              case 26:
                _context.prev = 26;
                _context.t1 = _context["catch"](2);

                _iterator6.e(_context.t1);

              case 29:
                _context.prev = 29;

                _iterator6.f();

                return _context.finish(29);

              case 32:
                _context.next = 34;
                return n;

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, removeOrphans, this, [[2, 26, 29, 32]]);
      })
    }, {
      key: "matchingBlocks",
      value: function matchingBlocks() {
        var e = [];
        return this.findMatchingBlocks(0, this.oldWords.length, 0, this.newWords.length, e), e;
      }
    }, {
      key: "findMatchingBlocks",
      value: function findMatchingBlocks(e, t, n, s, r) {
        var i = this.findMatch(e, t, n, s);
        null !== i && (e < i.startInOld && n < i.startInNew && this.findMatchingBlocks(e, i.startInOld, n, i.startInNew, r), r.push(i), i.endInOld < t && i.endInNew < s && this.findMatchingBlocks(i.endInOld, t, i.endInNew, s, r));
      }
    }, {
      key: "findMatch",
      value: function findMatch(e, t, n, s) {
        for (var _r5 = this.matchGranularity; _r5 > 0; _r5--) {
          var _o4 = new i();

          _o4.blockSize = _r5, _o4.repeatingWordsAccuracy = this.repeatingWordsAccuracy, _o4.ignoreWhitespaceDifferences = this.ignoreWhiteSpaceDifferences;

          var _l4 = new x(this.oldWords, this.newWords, e, t, n, s, _o4).findMatch();

          if (null !== _l4) return _l4;
        }

        return null;
      }
    }]);

    return v;
  }();

  v.execute = function (e, t) {
    return new v(e, t).build();
  };

  t.default = v;
}, function (e, t, n) {
  e.exports = n(0);
}]);